<template>
  <GraphqlDataTable
    :query="query"
    :order-by="initialOrder"
    :column-black-list="['id']"
    :filter-black-list="['accounts']"
    :additional-query-variables="{ client: clientRelationId }"
    :search-placeholder="$t('Search client team…')"
    max-height-adjustment="15vh"
  />
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import { graphql } from '@/gql'
import { SortOrder, ClientRelationTeamOrderByColumn } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const query = graphql(`
  query ClientTeamMembersTableQuery(
    $accounts: [ID!]
    $client: ID!
    $search: String
    $page: Int!
    $first: Int!
    $orderBy: [ClientRelationTeamOrderByClauseInput!]
    $accountRoles: [CompanyTeamRole!]
    $hasPhone: Boolean
  ) {
    clientRelationTeam(
      accounts: $accounts
      client: $client
      search: $search
      page: $page
      first: $first
      orderBy: $orderBy
      accountRoles: $accountRoles
      hasPhone: $hasPhone
    ) {
      data {
        id
        ...TeamMemberNameColumn
        ...TeamMemberAccountRoleColumn
        ...TeamMemberEmailColumn
        ...TeamMemberPhoneColumn
      }
    }
  }
`) as TypedQueryDocumentNode

defineProps<{ clientRelationId: string }>()

const initialOrder = {
  field: ClientRelationTeamOrderByColumn.AccountRole,
  order: SortOrder.Asc,
}
</script>
